import { Stack, SxProps, Theme, Typography } from '@mui/material'

import { ReactComponent as Quotes } from '@images/quotes.svg'

import {
  authorNameSx,
  authorWrapperSx,
  containerSx,
  contentSx,
  quotesIconSx,
  textSx,
} from './styles'

export interface ITestimonialProps {
  testimonialText: string
  personName: string
  personPosition: string
  containerSx?: SxProps<Theme>
  textSx?: SxProps<Theme>
  variant?: 'dark' | 'white'
}

const Testimonial = ({
  testimonialText,
  personName,
  personPosition,
  variant = 'white',
  containerSx: containerOverrideSx,
  textSx: textOverrideSx,
}: ITestimonialProps) => {
  const isDarkVariant = variant === 'dark'

  return (
    <Stack
      direction="row"
      sx={
        {
          ...containerSx({ darkVariant: isDarkVariant }),
          ...containerOverrideSx,
        } as SxProps<Theme>
      }
    >
      <Stack sx={contentSx}>
        <Typography
          variant="body2"
          sx={
            {
              ...textSx({ darkVariant: isDarkVariant }),
              ...textOverrideSx,
            } as SxProps<Theme>
          }
        >
          {testimonialText}
        </Typography>
        <Stack direction="row" sx={authorWrapperSx}>
          <Typography
            variant={isDarkVariant ? 'body1' : 'subtitle2'}
            sx={authorNameSx({ darkVariant: isDarkVariant })}
          >
            <b>{personName} - </b>
            <Typography
              variant={isDarkVariant ? 'body1' : 'body2'}
              component="span"
            >
              {' '}
              {personPosition}
            </Typography>
          </Typography>
        </Stack>
      </Stack>
      <Quotes style={quotesIconSx} />
    </Stack>
  )
}

export { Testimonial }
